import React, { useState } from "react";
import GridTable from "cvmgmt-cube-grid-table";
import { getEnv } from "../../../Constants/env";
import ConfirmModal from "../../Modals/ConfirmModal";
import { adminApprovaDeny } from "../../../services/RequestAccess/RequestAccess";
import { triggerToast } from "../../../utils/toast";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useIdToken } from "../../../hooks/useAuthSession";

interface RoleActivityProps {
  workdayID: string;
}

const RoleActivity: React.FC<RoleActivityProps> = ({ workdayID }) => {
  const navigate = useNavigate();
  const idToken = useIdToken();
  const [refresh, setRefresh] = useState<number>(0);
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [modalMessage, setModalMessage] = useState<string>("");
  const [revokeData, setRevokeData] = useState<any | null>(null);
  const { env } = useSelector((state: any) => state?.createApplication);

  const handleRevoke = async (rowData: any) => {
    const payload = {
      action: "revoked",
      accessRoleList: [
        {
          accessRoleId: rowData?.access_request_id,
          subrequestId: rowData?.subrequest_id,
          approvedRoleIds: [],
          deniedRoleIds: [],
          comment: modalMessage,
        },
      ],
    };

    try {
      const response = await adminApprovaDeny(payload);
      if (response?.status.toLowerCase() === "success") {
        triggerToast("Request is successfully revoked", "success");
      } else {
        triggerToast(
          "Something went wrong! Please try after sometime.",
          "error",
        );
      }
    } catch (error) {
      triggerToast("An error occurred while processing your request.", "error");
    } finally {
      setRefresh((prev) => prev + 1);
      setIsModalOpen(false);
      setModalMessage("");
    }
  };
  return (
    <>
      {idToken !== null && (
        <GridTable
          title={"Role Access"}
          refresh={refresh}
          style={{
            height: "calc(100vh - 33.5rem)",
            maxWidth: "calc(100vw - 4rem)",
          }}
          customPayload={true}
          isCustomizeColumns={false}
          isPagination={true}
          apiConfig={{
            url: `${getEnv()?.baseURL}/user/userActivityDetails?env=${env}&workday_id=${workdayID}`,
            data: {
              sortingFilter: {
                filter: [],
                sort: [],
                page: {
                  limit: 25,
                  offset: 0,
                },
              },
            },
            headers: {
              Authorization: idToken,
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            documentUrl: "",
          }}
          onRowClick={(_: any, row: any) => {
            const rowData = row?.original;
            navigate(`/user-access/${workdayID}/features-permissions`, {
              state: {
                userId: rowData?.user_id,
                roleId: rowData?.role_id,
                workdayID,
                role: rowData?.role,
                accessStatus: rowData?.access_status,
                userName: rowData?.user_name,
              },
            });
          }}
          cellActions={[
            {
              event: "Revoke",
              callback: (event, data) => {
                setRevokeData(data?.row?.original ?? null);
                setIsModalOpen(true);
              },
              icon: false,
            },
          ]}
          showLoader={false}
        />
      )}
      <ConfirmModal
        value={modalMessage}
        limitmessage={"Reason for Revoking"}
        modalMessage={
          "Please provide a short reason for denying the request in the field below."
        }
        isOpen={isModalOpen}
        headLabel={"Revoke Access"}
        handleClose={() => {
          setIsModalOpen(false);
          setModalMessage("");
        }}
        handleConfirm={() => handleRevoke(revokeData)}
        cancelButtonLabel={"Cancel"}
        confirmButtonLabel={"Revoke"}
        confirmButtonStyle="danger"
        handleTextFeild={(value: string) => {
          setModalMessage((prev) => value);
        }}
      />
    </>
  );
};

export default RoleActivity;
